const { authapiUrl } = require('../config');
const axios = require("axios");
const authApi = axios.create({

baseURL: process.env.REACT_APP_AUTH_API_URL,

})

export default authApi
